import {useState} from 'react';
import {I18n} from '@aws-amplify/core';
import {ButtonProps} from '@mantine/core';
import {FlexiAddButton} from '@flexinet/ui-components';

import {AddFormDrawer} from '../drawers/AddFormDrawer';
import {moduleConfig} from '../config';

export const AddRecordButton = (props: ButtonProps) => {
    const [drawerOpened, setDrawerOpened] = useState(false);

    // The button stays mounted while the drawer is open, so focus returns to it on close.
    return (
        <>
            <FlexiAddButton
                data-testid='billable-units-add'
                onClick={() => setDrawerOpened(true)}
                {...props}
            >
                {`${I18n.get('Add')} ${I18n.get(moduleConfig.titles.singular)}`}
            </FlexiAddButton>
            {drawerOpened && (
                <AddFormDrawer
                    opened={drawerOpened}
                    onClose={() => setDrawerOpened(false)}
                />
            )}
        </>
    );
};
